import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProductionDashboard from './pages/ProductionDashboard';
import NebimDashboard from './pages/NebimDashboard';
import WarehouseDashboard from './pages/WarehouseDashboard';
import ContentDashboard from './pages/ContentDashboard';
import VisualDashboard from './pages/VisualDashboard';
import AdminPanel from './pages/AdminPanel';
import CategoryManagement from './pages/CategoryManagement';
import TicimaxCategoryManagement from './pages/TicimaxCategoryManagement';
import ErpDashboard from './pages/ErpDashboard';
import PublishDashboard from './pages/PublishDashboard';
import TicimaxContentPanel from './pages/TicimaxContentPanel';
import CampaignChecklist from './pages/CampaignChecklist';
import PricesDashboard from './pages/PricesDashboard';
import AdminCustomScan from './pages/AdminCustomScan';
import './index.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="min-h-screen bg-gray-50">
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 3000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/production"
              element={
                <PrivateRoute allowedRoles={['production']}>
                  <ProductionDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/nebim"
              element={
                <PrivateRoute allowedRoles={['nebim']}>
                  <NebimDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/warehouse"
              element={
                <PrivateRoute allowedRoles={['warehouse']}>
                  <WarehouseDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/content"
              element={
                <PrivateRoute allowedRoles={['content', 'admin']}>
                  <ContentDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/visual"
              element={
                <PrivateRoute allowedRoles={['visual', 'admin']}>
                  <VisualDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/erp"
              element={
                <PrivateRoute allowedRoles={['erp']}>
                  <ErpDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/publish"
              element={
                <PrivateRoute allowedRoles={['publish', 'admin']}>
                  <PublishDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/users"
              element={
                <PrivateRoute allowedRoles={['admin']}>
                  <AdminPanel />
                </PrivateRoute>
              }
            />
            <Route
              path="/categories"
              element={
                <PrivateRoute allowedRoles={['admin', 'category']}>
                  <CategoryManagement />
                </PrivateRoute>
              }
            />
            <Route
              path="/ticimax-categories"
              element={
                <PrivateRoute allowedRoles={['admin', 'category']}>
                  <TicimaxCategoryManagement />
                </PrivateRoute>
              }
            />
            <Route
              path="/ticimax-content"
              element={
                <PrivateRoute allowedRoles={['content', 'admin']}>
                  <TicimaxContentPanel />
                </PrivateRoute>
              }
            />
            <Route
              path="/campaign-checklist"
              element={
                <PrivateRoute>
                  <CampaignChecklist />
                </PrivateRoute>
              }
            />
            <Route
              path="/prices"
              element={
                <PrivateRoute allowedRoles={['production', 'nebim', 'admin']}>
                  <PricesDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/custom-scan"
              element={
                <PrivateRoute allowedRoles={['admin']}>
                  <AdminCustomScan />
                </PrivateRoute>
              }
            />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
